module.exports = __webpack_public_path__ + "static/media/masaluda.82ded43a.png";